<script>
    import lookups from "../../../stores/lookupStore";

    import DisplayRow from "../../../components/DisplayRow.svelte";
    import FormRow from "../../../components/FormRow.svelte";
    import FormColumn from "../../../components/FormColumn.svelte";
    import TextDisplay from "../../../components/TextDisplay.svelte";
    import Select from "../../../components/Select.svelte";
    import DatePicker from "../../../components/DatePicker.svelte";
    import DeleteButton from "../../../components/buttons/DeleteButton.svelte";
    import AddButton from "../../../components/buttons/AddButton.svelte";

    export let surgery;
    export let disabled;

    const implantTypeOptions = [
        { id: "Mesh", name: "Mesh" },
        { id: "Tape", name: "Tape" },
    ];

    const implantOptions = $lookups.implantLookups
        .filter((i) => i.implantManufacturer === "Astora")
        .map((i) => ({ id: i.id, name: i.name, type: i.implantType }));

    const handleAddImplant = () => {
        surgery.surgeryImplants.push({ implantId: null });
        surgery.surgeryImplants = [...surgery.surgeryImplants];
    };

    const handleDeleteImplant = (index) => {
        surgery.surgeryImplants.splice(index, 1);
        surgery.surgeryImplants = [...surgery.surgeryImplants];
    };

    const handleImplantChange = (e, index) => {
        let option = implantOptions.findIndex(i => i.id == e.target.value);

        if (option >= 0) {
            surgery.surgeryImplants[index].implantName = implantOptions[option].name;
        }
    };

    const initialise = () => {};

    initialise();
</script>

<div>
    {#if disabled || !surgery.addedByQuestionnaire}
        <DisplayRow>
            <FormColumn cols="6">
                <TextDisplay
                    label="Date of surgery"
                    value={surgery.dateSurgery}
                />
            </FormColumn>
        </DisplayRow>

        {#if surgery.surgeryImplants && surgery.surgeryImplants.length}
            <DisplayRow>
                {#each surgery.surgeryImplants as implant, i}
                    <FormColumn cols="2" class="mb-2">
                        <label for="implantType{i}" class:desktop={i > 0}>Implant type</label>
                        <TextDisplay id="implantType{i}" readonly value={implant.implantType} />
                    </FormColumn>
                    <FormColumn cols="10" class="mb-2">
                        <label for="implantName{i}" class:desktop={i > 0}>Implant name</label>
                        <TextDisplay id="implantName{i}" readonly value={implant.implantName} />
                    </FormColumn>
                {/each}
            </DisplayRow>
        {/if}
    {:else if surgery.addedByQuestionnaire}
        <FormRow>
            <FormColumn>
                <DatePicker
                    required
                    {disabled}
                    id="e_dateOfDeath"
                    label="Date of surgery"
                    validator={true}
                    start={new Date(1950, 0, 1)}
                    end={new Date()}
                    placeholder="e.g. 01/05/1987"
                    bind:formattedSelected={surgery.dateSurgery}
                    openOnClass="calendar-icon"
                />
            </FormColumn>
            <FormColumn class="last">
                <div class="button-wrapx">
                    <DeleteButton on:delete>Delete surgery</DeleteButton>
                </div>
            </FormColumn>
        </FormRow>

        <FormRow>

            <FormColumn cols="12" class="last">
                <AddButton on:add={handleAddImplant}>Add Implant</AddButton>
            </FormColumn>

            {#if surgery.surgeryImplants && surgery.surgeryImplants.length}
                {#each surgery.surgeryImplants as implant, i (implant)}
                    <FormColumn cols="2" class="mb-2">
                        <label for="qimplantType{i}" class:desktop={i > 0}>Type</label>
                        <Select required
                            id="qimplantType{i}"
                            bind:value={implant.implantType}
                            optionList={implantTypeOptions}
                        />
                    </FormColumn>
                    <div class="col-md-10 mb-2" class:button-column={surgery.surgeryImplants.length > 1}>
                        <label for="qimplantId{i}" class:desktop={i > 0}>Implant name</label>
                        <Select required
                            id="qimplantId{i}"
                            disabled={!implant.implantType}
                            bind:value={implant.implantId}
                            optionList={implantOptions.filter(
                                (o) => o.type == implant.implantType,
                            )}
                            on:change={(e) => handleImplantChange(e, i)}
                        />

                        {#if surgery.surgeryImplants.length > 1}
                            <div class="button-wrap">
                                <DeleteButton
                                    title="Delete implant"
                                    on:delete={() => handleDeleteImplant(i)}
                                ></DeleteButton>
                            </div>
                        {/if}
                    </div>
                {/each}
            {/if}
        </FormRow>
    {/if}

    <hr class="primary" />
</div>


<style>

    .button-column {
        position: relative;
        padding-right: 50px;
    }

    .button-wrap {
        position: absolute;
        bottom: 26px;
        right: 10px;
    }

    @media (min-width:768px) {
        .desktop {
            display: none;
        }
    }

</style>
